import { openapi } from "../../../../openapi";

openapi.enhanceEndpoints({
  endpoints: {
    getChecklistsByReviewByReviewId: {
      providesTags: ["Checklist"],
    },
    putChecklistsByChecklistIdDkApprovalToggle: {
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(openapi.util.invalidateTags(["Checklist"]));
        } catch {
          // no-op: leave cache untouched on failed toggle
        }
      },
    },
  },
});
